module.exports = __webpack_public_path__ + "img/identity_yl.860966af.png";